module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/trending-up-orange.c806cc57.svg";